import { ProductGoToActionBlock } from "./ProductGoToActionBlock";
import { UploadDataBtn } from "../ui/buttons";

export const UploadDataBlock = ({ campaign_id }: { campaign_id: string }) => {
  return (
    <ProductGoToActionBlock
      title="No Accounts Data"
      texts={[
        "Share your target accounts and contacts data to unlock buying committee insights" +
          " and contacts engagement tracking.",
      ]}
      btn={<UploadDataBtn campaign_id={campaign_id} />}
    />
  );
};
